import React from 'react';
import { Box, Button, HStack, Text, VStack } from 'native-base';
import { CachedIcon, GreenCheckIcon, UsersIcon } from '../../../assets';
import { DotFlashing } from '../../DotFlashing';
import { ESignStatus } from '../../../hooks';
const ESignButton = _ref => {
  let {
    status,
    disclosures,
    isTokenWaiting,
    getToken,
    selected,
    isRefetching,
    setSelectedDisclosureUserName
  } = _ref;
  if (status === ESignStatus.SCHEDULE_CLOSING) return null;
  return /*#__PURE__*/React.createElement(Box, {
    w: {
      base: 'full',
      md: 201,
      lg: 201
    },
    h: "14",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: {
      lg: 'center',
      md: 'center',
      base: undefined
    }
  }, isTokenWaiting || !!isRefetching ? /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    alignItems: "center",
    justifyContent: {
      base: 'center',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(CachedIcon, null), /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#656565",
    accessibilityLabel: "updating",
    testID: "updating-esign"
  }, "UPDATING")), /*#__PURE__*/React.createElement(Box, {
    mt: "2"
  }, /*#__PURE__*/React.createElement(DotFlashing, null))) : status === 'COMPLETED' ? /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    alignItems: "center",
    justifyContent: {
      base: 'center',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(GreenCheckIcon, null), /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#03906A",
    accessibilityLabel: status,
    testID: status
  }, status)) : status === 'WAITING FOR CO-BORROWER' ? /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    alignItems: "center",
    justifyContent: {
      base: 'center',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(UsersIcon, null), /*#__PURE__*/React.createElement(VStack, {
    accessibilityLabel: "waiting for co borrower"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#656565",
    accessibilityLabel: "waiting for"
  }, "WAITING FOR"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#656565",
    accessibilityLabel: "co borrower"
  }, "CO-BORROWER"))) : status !== null && status !== void 0 && status.includes('Waiting for ') ? /*#__PURE__*/React.createElement(HStack, {
    space: "2",
    alignItems: "center",
    justifyContent: {
      base: 'center',
      md: 'flex-end',
      lg: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement(UsersIcon, null), /*#__PURE__*/React.createElement(VStack, {
    accessibilityLabel: "waiting for co borrower"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#656565",
    accessibilityLabel: "waiting for"
  }, "WAITING FOR"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    color: "#656565",
    accessibilityLabel: "co borrower",
    textTransform: 'uppercase',
    maxW: {
      sm: '205',
      lg: '150'
    }
  }, status.replace('Waiting for ', '')))) : /*#__PURE__*/React.createElement(Button, {
    variant: "freedom",
    _text: {
      fontSize: 'lg',
      fontFamily: 'body',
      fontWeight: 'medium'
    },
    isLoading: isTokenWaiting,
    isDisabled: !!selected,
    accessibilityLabel: "sign disclosures",
    testID: "sign disclosures",
    onPress: () => {
      setSelectedDisclosureUserName(disclosures.userName);
      getToken(disclosures);
    },
    w: {
      base: 'full',
      md: 201,
      lg: 201
    },
    h: "14"
  }, "SIGN DISCLOSURES"));
};
export default ESignButton;
//# sourceMappingURL=ESignButton.js.map